<div class="min-h-screen bg-gradient-to-br from-[#061126] via-[#0B1736] to-[#13254D] text-white overflow-hidden">

  <!-- NAVBAR -->
  <nav class="border-b border-white/10 backdrop-blur-xl bg-white/5 sticky top-0 z-50">

    <div class="w-full px-4 sm:px-6 lg:px-8 xl:px-12">

      <div class="flex items-center justify-between py-4">

        <!-- LOGO -->
        <div class="flex items-center gap-3">

          <div class="w-20 h-20 rounded-xl overflow-hidden flex items-center justify-center">
         <img 
           src="/logo.png" 
            alt="Rozgar Sarthi"
           class="w-full h-full object-cover rounded-xl"
         >
        </div>

          

          <div>
            <h2 class="text-xl sm:text-3xl font-black text-[#FFD166] leading-none">
              Rozgar Sarthi
            </h2>

            <p class="text-[10px] sm:text-xs text-gray-300 mt-1">
              Startup • Funding • Business Growth
            </p>
          </div>

        </div>

        <!-- DESKTOP MENU -->
        <div class="hidden md:flex items-center gap-8 font-semibold text-sm">

          <a href="#home" class="hover:text-[#FFD166] transition duration-300 relative after:absolute after:left-0 after:-bottom-1 after:h-[2px] after:w-0 after:bg-[#FFD166] after:transition-all after:duration-300 hover:after:w-full">
            Home
          </a>

          <a href="#services" class="hover:text-[#FFD166] transition duration-300 relative after:absolute after:left-0 after:-bottom-1 after:h-[2px] after:w-0 after:bg-[#FFD166] after:transition-all after:duration-300 hover:after:w-full">
            Services
          </a>

          <a href="#funding" class="hover:text-[#FFD166] transition duration-300 relative after:absolute after:left-0 after:-bottom-1 after:h-[2px] after:w-0 after:bg-[#FFD166] after:transition-all after:duration-300 hover:after:w-full">
            Funding
          </a>

          <a href="#contact" class="hover:text-[#FFD166] transition duration-300 relative after:absolute after:left-0 after:-bottom-1 after:h-[2px] after:w-0 after:bg-[#FFD166] after:transition-all after:duration-300 hover:after:w-full">
            Contact
          </a>

        </div>

        <!-- MOBILE BUTTON -->
        <button
          (click)="menuOpen = !menuOpen"
          class="md:hidden bg-white/10 border border-white/10 p-3 rounded-xl"
        >
          ☰
        </button>

      </div>

      <!-- MOBILE MENU -->
      <div
        *ngIf="menuOpen"
        class="md:hidden pb-6 flex flex-col gap-5 text-lg font-semibold"
      >

        <a href="#">Home</a>
        <a href="#">Services</a>
        <a href="#">Funding</a>
        <a href="#">Contact</a>

      </div>

    </div>

  </nav>

  <!-- HERO -->
  <section id="home" class="relative">

    <div class="w-full px-4 sm:px-6 lg:px-8 xl:px-12 py-8 lg:py-14">

      <div class="grid lg:grid-cols-[1.1fr_.9fr] gap-10 xl:gap-16 items-center">

        <!-- LEFT -->
        <div>

          <!-- TAG -->
          <div class="inline-flex items-center gap-2 px-5 py-3 rounded-full bg-white/10 border border-white/10 mb-8 text-sm">
            🚀 India’s Smart Business Platform
          </div>

          <!-- HEADING -->
          <h1 class="text-5xl sm:text-6xl lg:text-7xl xl:text-[90px] font-black leading-[1.05] tracking-tight">

            बेरोजगार युवाओं को

            <span class="text-[#FFD166]">
              नया रोजगार
            </span>

            शुरू करने में मदद।

          </h1>

          <!-- TEXT -->
          <p class="text-base sm:text-lg text-gray-300 leading-9 mt-8 max-w-3xl">

            Company Registration, GST, Startup India,
            Branding, Marketing, Website Development,
            PMEGP, Mudra Loan, CM Yuva Udyami
            और सभी Digital Business Services.

          </p>

          <!-- BUTTONS -->
          <div class="flex flex-wrap gap-5 mt-10">

            <button class="bg-[#FFD166] hover:bg-[#ffcb45] text-black px-8 py-4 rounded-2xl font-bold shadow-2xl transition">

              Get Started

            </button>

            <button class="border border-white/20 hover:bg-white/10 px-8 py-4 rounded-2xl font-semibold transition">

              Explore Services

            </button>

          </div>

          <!-- STATS -->
          <div class="grid grid-cols-2 md:grid-cols-4 gap-4 mt-12">

            <div class="bg-white/5 border border-white/10 rounded-3xl p-5">
              <h3 class="text-3xl font-black text-[#FFD166]">
                500+
              </h3>
              <p class="text-gray-300 text-sm mt-2">
                Business Setup
              </p>
            </div>

            <div class="bg-white/5 border border-white/10 rounded-3xl p-5">
              <h3 class="text-3xl font-black text-[#FFD166]">
                ₹10Cr+
              </h3>
              <p class="text-gray-300 text-sm mt-2">
                Funding Support
              </p>
            </div>

            <div class="bg-white/5 border border-white/10 rounded-3xl p-5">
              <h3 class="text-3xl font-black text-[#FFD166]">
                24/7
              </h3>
              <p class="text-gray-300 text-sm mt-2">
                Expert Guidance
              </p>
            </div>

            <div class="bg-white/5 border border-white/10 rounded-3xl p-5">
              <h3 class="text-3xl font-black text-[#FFD166]">
                100%
              </h3>
              <p class="text-gray-300 text-sm mt-2">
                Online Process
              </p>
            </div>

          </div>

        </div>

        <!-- RIGHT -->
        <div>

          <div class="bg-white/5 border border-white/10 rounded-[35px] p-5 sm:p-8 backdrop-blur-xl shadow-2xl">

            <!-- TOP -->
            <div class="flex items-center justify-between mb-8">

              <div>
                <h2 class="text-3xl sm:text-5xl font-black">
                  Government Schemes
                </h2>

                <p class="text-gray-300 mt-2">
                  Funding & Startup Support
                </p>
              </div>

              <div class="w-16 h-16 rounded-2xl bg-[#FFD166]/20 flex items-center justify-center text-3xl">
                💼
              </div>

            </div>

            <!-- CARDS -->
            <div class="space-y-5">

              <div class="bg-gradient-to-r from-[#40310D] to-[#4B5563] rounded-3xl p-6 border border-[#FFD166]/20">

                <div class="flex items-center justify-between gap-4">

                  <div>
                    <h3 class="text-3xl font-black">
                      PMEGP Loan
                    </h3>

                    <p class="text-gray-300 mt-2">
                      New Business Funding Support
                    </p>
                  </div>

                  <div class="text-5xl">
                    🚀
                  </div>

                </div>

              </div>

              <div class="bg-gradient-to-r from-[#173A8D] to-[#244EB8] rounded-3xl p-6 border border-blue-300/20">

                <div class="flex items-center justify-between gap-4">

                  <div>
                    <h3 class="text-3xl font-black">
                      Mudra Loan
                    </h3>

                    <p class="text-gray-300 mt-2">
                      Small Business Loan Assistance
                    </p>
                  </div>

                  <div class="text-5xl">
                    💰
                  </div>

                </div>

              </div>

              <div class="bg-gradient-to-r from-[#4C1D95] to-[#6D28D9] rounded-3xl p-6 border border-purple-300/20">

                <div class="flex items-center justify-between gap-4">

                  <div>
                    <h3 class="text-3xl font-black">
                      Startup India
                    </h3>

                    <p class="text-gray-300 mt-2">
                      Registration & Recognition
                    </p>
                  </div>

                  <div class="text-5xl">
                    🏢
                  </div>

                </div>

              </div>

            </div>

          </div>

        </div>

      </div>

    </div>

  </section>

  <section id="services" class="relative bg-[#071633] py-16 lg:py-24 overflow-hidden">

  <!-- BACKGROUND EFFECT -->
  <div class="absolute top-0 left-0 w-72 h-72 bg-[#FFD15C]/10 blur-[120px]"></div>
  <div class="absolute bottom-0 right-0 w-72 h-72 bg-blue-500/10 blur-[120px]"></div>

  <div class="relative w-full px-4 sm:px-6 lg:px-8 xl:px-12">

    <!-- HEADING -->
    <div class="text-center mb-16">

      <p class="text-[#FFD15C] font-bold uppercase tracking-[4px]">
        हमारी सेवाएं
      </p>

      <h2 class="text-4xl lg:text-6xl font-black text-white mt-5">
        Complete Business Growth Solutions
      </h2>

      <p class="text-gray-300 mt-6 max-w-4xl mx-auto text-lg leading-9">
        Rozgar Sarthi आपके Business Registration,
        Funding, Branding, Digital Growth और Government
        Schemes से जुड़ी सभी सेवाएं एक ही जगह प्रदान करता है।
      </p>

    </div>


    <!-- SERVICES GRID -->
    <div class="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">

      <!-- CARD -->
      <div class="rounded-3xl bg-white/5 border border-white/10 p-8 hover:bg-[#11214B] transition">

        <div class="text-5xl mb-6">🏢</div>

        <h3 class="text-3xl font-black text-white">
          Company Registration
        </h3>

        <p class="text-gray-300 mt-4 leading-8">
          Private Limited, LLP, OPC एवं सभी प्रकार की कंपनी रजिस्ट्रेशन सेवाएं।
        </p>

      </div>

      <!-- CARD -->
      <div class="rounded-3xl bg-white/5 border border-white/10 p-8 hover:bg-[#11214B] transition">

        <div class="text-5xl mb-6">📑</div>

        <h3 class="text-3xl font-black text-white">
          GST Registration
        </h3>

        <p class="text-gray-300 mt-4 leading-8">
          GST Registration, Return Filing और GST Consultancy Support।
        </p>

      </div>

      <!-- CARD -->
      <div class="rounded-3xl bg-white/5 border border-white/10 p-8 hover:bg-[#11214B] transition">

        <div class="text-5xl mb-6">🎨</div>

        <h3 class="text-3xl font-black text-white">
          Branding & Marketing
        </h3>

        <p class="text-gray-300 mt-4 leading-8">
          Brand Identity, Social Media Marketing एवं Business Promotion।
        </p>

      </div>

      <!-- CARD -->
      <div class="rounded-3xl bg-white/5 border border-white/10 p-8 hover:bg-[#11214B] transition">

        <div class="text-5xl mb-6">🌐</div>

        <h3 class="text-3xl font-black text-white">
          Website Development
        </h3>

        <p class="text-gray-300 mt-4 leading-8">
          Professional Website, Ecommerce Store एवं Digital Presence Setup।
        </p>

      </div>

      <!-- CARD -->
      <div class="rounded-3xl bg-white/5 border border-white/10 p-8 hover:bg-[#11214B] transition">

        <div class="text-5xl mb-6">💻</div>

        <h3 class="text-3xl font-black text-white">
          Digital Setup
        </h3>

        <p class="text-gray-300 mt-4 leading-8">
          Business Digitalization, Payment Gateway एवं Online Tools Setup।
        </p>

      </div>

      <!-- CARD -->
      <div class="rounded-3xl bg-white/5 border border-white/10 p-8 hover:bg-[#11214B] transition">

        <div class="text-5xl mb-6">🚀</div>

        <h3 class="text-3xl font-black text-white">
          Startup India
        </h3>

        <p class="text-gray-300 mt-4 leading-8">
          DPIIT Recognition एवं Startup India Registration Assistance।
        </p>

      </div>

      <!-- CARD -->
      <div class="rounded-3xl bg-white/5 border border-white/10 p-8 hover:bg-[#11214B] transition">

        <div class="text-5xl mb-6">🏭</div>

        <h3 class="text-3xl font-black text-white">
          MSME Registration
        </h3>

        <p class="text-gray-300 mt-4 leading-8">
          Udyam Registration एवं MSME Benefits Guidance।
        </p>

      </div>

      <!-- CARD -->
      <div class="rounded-3xl bg-white/5 border border-white/10 p-8 hover:bg-[#11214B] transition">

        <div class="text-5xl mb-6">📊</div>

        <h3 class="text-3xl font-black text-white">
          Business Consultancy
        </h3>

        <p class="text-gray-300 mt-4 leading-8">
          Business Planning, Growth Strategy एवं Startup Consultancy।
        </p>

      </div>

      <!-- CARD -->
      <div class="rounded-3xl bg-white/5 border border-white/10 p-8 hover:bg-[#11214B] transition">

        <div class="text-5xl mb-6">⚖️</div>

        <h3 class="text-3xl font-black text-white">
          Trademark & Legal Support
        </h3>

        <p class="text-gray-300 mt-4 leading-8">
          Trademark Registration एवं Legal Documentation Services।
        </p>

      </div>

    </div>


    <!-- FUNDING SECTION -->
    <div id="funding" class="mt-24">

      <div class="text-center mb-14">

        <p class="text-[#FFD15C] font-bold uppercase tracking-[4px]">
          Funding Support
        </p>

        <h2 class="text-4xl lg:text-6xl font-black text-white mt-5">
          Loan एवं Funding सहायता
        </h2>

      </div>


      <div class="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">

        <!-- FUND CARD -->
        <div class="rounded-3xl bg-gradient-to-br from-yellow-700/40 to-yellow-500/10 border border-yellow-500/20 p-8">

          <div class="text-5xl mb-6">💼</div>

          <h3 class="text-3xl font-black text-white">
            CM Yuva Udyami
          </h3>

          <p class="text-gray-200 mt-4 leading-8">
            मुख्यमंत्री युवा उद्यमी योजना सहायता एवं आवेदन मार्गदर्शन।
          </p>

        </div>

        <!-- FUND CARD -->
        <div class="rounded-3xl bg-gradient-to-br from-blue-700/40 to-blue-500/10 border border-blue-500/20 p-8">

          <div class="text-5xl mb-6">🚀</div>

          <h3 class="text-3xl font-black text-white">
            PMEGP Loan
          </h3>

          <p class="text-gray-200 mt-4 leading-8">
            PMEGP Loan एवं Government Subsidy Support।
          </p>

        </div>

        <!-- FUND CARD -->
        <div class="rounded-3xl bg-gradient-to-br from-purple-700/40 to-pink-500/10 border border-purple-500/20 p-8">

          <div class="text-5xl mb-6">💰</div>

          <h3 class="text-3xl font-black text-white">
            Mudra Loan
          </h3>

          <p class="text-gray-200 mt-4 leading-8">
            Small Business एवं Startup Loan Assistance।
          </p>

        </div>

        <!-- FUND CARD -->
        <div class="rounded-3xl bg-gradient-to-br from-green-700/40 to-green-500/10 border border-green-500/20 p-8">

          <div class="text-5xl mb-6">📈</div>

          <h3 class="text-3xl font-black text-white">
            Startup India Funding
          </h3>

          <p class="text-gray-200 mt-4 leading-8">
            Startup Funding एवं Investor Guidance।
          </p>

        </div>

        <!-- FUND CARD -->
        <div class="rounded-3xl bg-gradient-to-br from-cyan-700/40 to-cyan-500/10 border border-cyan-500/20 p-8">

          <div class="text-5xl mb-6">🏭</div>

          <h3 class="text-3xl font-black text-white">
            MSME Loan Support
          </h3>

          <p class="text-gray-200 mt-4 leading-8">
            MSME Business Funding एवं Expansion Loan Support।
          </p>

        </div>

        <!-- FUND CARD -->
        <div class="rounded-3xl bg-gradient-to-br from-red-700/40 to-red-500/10 border border-red-500/20 p-8">

          <div class="text-5xl mb-6">🏛️</div>

          <h3 class="text-3xl font-black text-white">
            Government Schemes
          </h3>

          <p class="text-gray-200 mt-4 leading-8">
            Government Subsidy एवं Scheme Guidance Support।
          </p>

        </div>

      </div>

    </div>

  </div>

</section>


<section class="relative bg-[#08152E] py-16 lg:py-24 overflow-hidden">

  <!-- BG EFFECT -->
  <div class="absolute top-0 right-0 w-96 h-96 bg-blue-500/10 blur-[120px]"></div>
  <div class="absolute bottom-0 left-0 w-96 h-96 bg-[#FFD15C]/10 blur-[120px]"></div>

  <div class="relative w-full px-4 sm:px-6 lg:px-8 xl:px-12">

    <div class="grid lg:grid-cols-2 gap-14 items-center">

      <!-- LEFT -->
      <div>

        <p class="text-[#FFD15C] uppercase tracking-[4px] font-bold">
          Why Choose Us
        </p>

        <h2 class="text-4xl lg:text-6xl font-black text-white mt-5 leading-tight">
          भारत के युवाओं और Businesses के लिए भरोसेमंद Partner
        </h2>

        <p class="text-gray-300 mt-8 text-lg leading-9">
          Rozgar Sarthi हजारों युवाओं, startups और business owners
          को registration, funding, branding और digital growth
          में सहायता प्रदान करता है।
        </p>

        <!-- FEATURES -->
        <div class="mt-10 space-y-6">

          <div class="flex gap-5">

            <div class="w-14 h-14 rounded-2xl bg-[#FFD15C]/20 flex items-center justify-center text-2xl">
              ✅
            </div>

            <div>

              <h3 class="text-2xl font-black text-white">
                Fast & Professional Service
              </h3>

              <p class="text-gray-300 mt-2 leading-8">
                Quick documentation एवं expert business support।
              </p>

            </div>

          </div>

          <div class="flex gap-5">

            <div class="w-14 h-14 rounded-2xl bg-blue-500/20 flex items-center justify-center text-2xl">
              💼
            </div>

            <div>

              <h3 class="text-2xl font-black text-white">
                Startup & Loan Experts
              </h3>

              <p class="text-gray-300 mt-2 leading-8">
                Government schemes एवं funding guidance support।
              </p>

            </div>

          </div>

          <div class="flex gap-5">

            <div class="w-14 h-14 rounded-2xl bg-purple-500/20 flex items-center justify-center text-2xl">
              🌐
            </div>

            <div>

              <h3 class="text-2xl font-black text-white">
                Complete Digital Solution
              </h3>

              <p class="text-gray-300 mt-2 leading-8">
                Website, branding, marketing एवं digital setup services।
              </p>

            </div>

          </div>

        </div>

      </div>


      <!-- RIGHT -->
      <div>

        <div class="grid grid-cols-2 gap-6">

          <!-- CARD -->
          <div class="rounded-3xl bg-white/5 border border-white/10 p-8">

            <h3 class="text-5xl font-black text-[#FFD15C]">
              500+
            </h3>

            <p class="text-white text-xl font-semibold mt-4">
              Business Setup
            </p>

          </div>

          <!-- CARD -->
          <div class="rounded-3xl bg-white/5 border border-white/10 p-8">

            <h3 class="text-5xl font-black text-[#FFD15C]">
              ₹10Cr+
            </h3>

            <p class="text-white text-xl font-semibold mt-4">
              Funding Guidance
            </p>

          </div>

          <!-- CARD -->
          <div class="rounded-3xl bg-white/5 border border-white/10 p-8">

            <h3 class="text-5xl font-black text-[#FFD15C]">
              24/7
            </h3>

            <p class="text-white text-xl font-semibold mt-4">
              Support
            </p>

          </div>

          <!-- CARD -->
          <div class="rounded-3xl bg-white/5 border border-white/10 p-8">

            <h3 class="text-5xl font-black text-[#FFD15C]">
              100%
            </h3>

            <p class="text-white text-xl font-semibold mt-4">
              Trusted Guidance
            </p>

          </div>

        </div>

      </div>

    </div>

  </div>

</section>


<section class="relative bg-[#08152E] py-16 lg:py-24 overflow-hidden">

  <!-- BG EFFECT -->
  <div class="absolute top-0 right-0 w-96 h-96 bg-[#FFD15C]/10 blur-[120px]"></div>

  <div class="relative w-full px-4 sm:px-6 lg:px-8 xl:px-12">

    <!-- HEADING -->
    <div class="text-center max-w-4xl mx-auto">

      <p class="text-[#FFD15C] uppercase tracking-[4px] font-bold">
        How It Works
      </p>

      <h2 class="text-4xl lg:text-6xl font-black text-white mt-5">
        Business शुरू करने का आसान Process
      </h2>

      <p class="text-gray-300 mt-6 text-lg leading-9">
        Rozgar Sarthi आपके business registration से लेकर funding
        और digital growth तक हर step में सहायता करता है।
      </p>

    </div>


    <!-- PROCESS -->
    <div class="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mt-20">


      <!-- STEP -->
      <div class="relative rounded-3xl bg-white/5 border border-white/10 p-8">

        <div class="w-16 h-16 rounded-2xl bg-[#FFD15C]/20 flex items-center justify-center text-3xl">
          📞
        </div>

        <div class="absolute -top-4 right-6 text-6xl font-black text-white/10">
          01
        </div>

        <h3 class="text-2xl font-black text-white mt-8">
          Contact Us
        </h3>

        <p class="text-gray-300 mt-4 leading-8">
          अपनी business requirement हमारे experts के साथ share करें।
        </p>

      </div>


      <!-- STEP -->
      <div class="relative rounded-3xl bg-white/5 border border-white/10 p-8">

        <div class="w-16 h-16 rounded-2xl bg-blue-500/20 flex items-center justify-center text-3xl">
          📑
        </div>

        <div class="absolute -top-4 right-6 text-6xl font-black text-white/10">
          02
        </div>

        <h3 class="text-2xl font-black text-white mt-8">
          Documentation
        </h3>

        <p class="text-gray-300 mt-4 leading-8">
          Registration एवं funding process के लिए documents verify किए जाते हैं।
        </p>

      </div>


      <!-- STEP -->
      <div class="relative rounded-3xl bg-white/5 border border-white/10 p-8">

        <div class="w-16 h-16 rounded-2xl bg-purple-500/20 flex items-center justify-center text-3xl">
          🚀
        </div>

        <div class="absolute -top-4 right-6 text-6xl font-black text-white/10">
          03
        </div>

        <h3 class="text-2xl font-black text-white mt-8">
          Approval & Setup
        </h3>

        <p class="text-gray-300 mt-4 leading-8">
          आपका business registration, website और digital setup complete किया जाता है।
        </p>

      </div>


      <!-- STEP -->
      <div class="relative rounded-3xl bg-white/5 border border-white/10 p-8">

        <div class="w-16 h-16 rounded-2xl bg-green-500/20 flex items-center justify-center text-3xl">
          📈
        </div>

        <div class="absolute -top-4 right-6 text-6xl font-black text-white/10">
          04
        </div>

        <h3 class="text-2xl font-black text-white mt-8">
          Grow Business
        </h3>

        <p class="text-gray-300 mt-4 leading-8">
          Funding, marketing एवं branding support से business growth।
        </p>

      </div>

    </div>

  </div>

</section>


<section class="relative bg-[#061126] py-16 lg:py-24 overflow-hidden">

  <!-- BG EFFECT -->
  <div class="absolute inset-0">
    <div class="absolute top-0 left-0 w-96 h-96 bg-blue-500/10 blur-[120px]"></div>
    <div class="absolute bottom-0 right-0 w-96 h-96 bg-[#FFD15C]/10 blur-[120px]"></div>
  </div>

  <div class="relative w-full px-4 sm:px-6 lg:px-8 xl:px-12">

    <!-- HEADING -->
    <div class="text-center max-w-4xl mx-auto">

      <p class="text-[#FFD15C] uppercase tracking-[4px] font-bold">
        Our Success
      </p>

      <h2 class="text-4xl lg:text-6xl font-black text-white mt-5 leading-tight">
        हजारों युवाओं और Businesses का भरोसा
      </h2>

      <p class="text-gray-300 mt-6 text-lg leading-9">
        Rozgar Sarthi ने startup registration,
        government schemes और digital growth में
        अनेक businesses को सफलता दिलाई है।
      </p>

    </div>

    <!-- COUNTER GRID -->
    <div class="grid sm:grid-cols-2 lg:grid-cols-4 gap-8 mt-20">

      <!-- CARD -->
      <div class="rounded-3xl bg-white/5 border border-white/10 p-10 text-center backdrop-blur-xl">

        <div class="text-6xl mb-5">
          🚀
        </div>

        <h3 class="text-5xl font-black text-[#FFD15C]">
          500+
        </h3>

        <p class="text-white text-xl font-semibold mt-4">
          Startup Registrations
        </p>

      </div>

      <!-- CARD -->
      <div class="rounded-3xl bg-white/5 border border-white/10 p-10 text-center backdrop-blur-xl">

        <div class="text-6xl mb-5">
          💰
        </div>

        <h3 class="text-5xl font-black text-[#FFD15C]">
          ₹10Cr+
        </h3>

        <p class="text-white text-xl font-semibold mt-4">
          Loan & Funding Guidance
        </p>

      </div>

      <!-- CARD -->
      <div class="rounded-3xl bg-white/5 border border-white/10 p-10 text-center backdrop-blur-xl">

        <div class="text-6xl mb-5">
          🌐
        </div>

        <h3 class="text-5xl font-black text-[#FFD15C]">
          100+
        </h3>

        <p class="text-white text-xl font-semibold mt-4">
          Website & Digital Setup
        </p>

      </div>

      <!-- CARD -->
      <div class="rounded-3xl bg-white/5 border border-white/10 p-10 text-center backdrop-blur-xl">

        <div class="text-6xl mb-5">
          ⭐
        </div>

        <h3 class="text-5xl font-black text-[#FFD15C]">
          24/7
        </h3>

        <p class="text-white text-xl font-semibold mt-4">
          Expert Support
        </p>

      </div>

    </div>

  </div>

</section>

<section class="relative bg-[#08152E] py-16 lg:py-24 overflow-hidden">

  <!-- BG EFFECT -->
  <div class="absolute top-0 right-0 w-96 h-96 bg-purple-500/10 blur-[120px]"></div>

  <div class="relative w-full px-4 sm:px-6 lg:px-8 xl:px-12">

    <!-- HEADING -->
    <div class="text-center max-w-4xl mx-auto">

      <p class="text-[#FFD15C] uppercase tracking-[4px] font-bold">
        Testimonials
      </p>

      <h2 class="text-4xl lg:text-6xl font-black text-white mt-5 leading-tight">
        हमारे Clients क्या कहते हैं
      </h2>

      <p class="text-gray-300 mt-6 text-lg leading-9">
        Rozgar Sarthi ने हजारों entrepreneurs और startups को
        business setup एवं funding guidance में सहायता दी है।
      </p>

    </div>


    <!-- TESTIMONIAL GRID -->
    <div class="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mt-20">

      <!-- CARD -->
      <div class="rounded-3xl bg-white/5 border border-white/10 p-8 backdrop-blur-xl">

        <!-- STARS -->
        <div class="text-[#FFD15C] text-2xl">
          ★★★★★
        </div>

        <p class="text-gray-200 mt-6 leading-9 text-lg">
          Rozgar Sarthi की मदद से मैंने अपना startup register कराया
          और Mudra Loan भी मिला। पूरी process बहुत professional थी।
        </p>

        <div class="flex items-center gap-4 mt-8">

          <div class="w-14 h-14 rounded-full bg-blue-500/20 flex items-center justify-center text-2xl">
            👨
          </div>

          <div>

            <h3 class="text-xl font-black text-white">
              Aman Verma
            </h3>

            <p class="text-gray-400">
              Startup Founder
            </p>

          </div>

        </div>

      </div>


      <!-- CARD -->
      <div class="rounded-3xl bg-white/5 border border-white/10 p-8 backdrop-blur-xl">

        <!-- STARS -->
        <div class="text-[#FFD15C] text-2xl">
          ★★★★★
        </div>

        <p class="text-gray-200 mt-6 leading-9 text-lg">
          GST registration, website और branding सभी services एक
          ही जगह मिल गई। Team का support काफी अच्छा था।
        </p>

        <div class="flex items-center gap-4 mt-8">

          <div class="w-14 h-14 rounded-full bg-green-500/20 flex items-center justify-center text-2xl">
            👩
          </div>

          <div>

            <h3 class="text-xl font-black text-white">
              Priya Sharma
            </h3>

            <p class="text-gray-400">
              Business Owner
            </p>

          </div>

        </div>

      </div>


      <!-- CARD -->
      <div class="rounded-3xl bg-white/5 border border-white/10 p-8 backdrop-blur-xl">

        <!-- STARS -->
        <div class="text-[#FFD15C] text-2xl">
          ★★★★★
        </div>

        <p class="text-gray-200 mt-6 leading-9 text-lg">
          Startup India registration और PMEGP guidance के लिए
          Rozgar Sarthi best platform है। Highly recommended।
        </p>

        <div class="flex items-center gap-4 mt-8">

          <div class="w-14 h-14 rounded-full bg-purple-500/20 flex items-center justify-center text-2xl">
            👨‍💼
          </div>

          <div>

            <h3 class="text-xl font-black text-white">
              Rohit Singh
            </h3>

            <p class="text-gray-400">
              Entrepreneur
            </p>

          </div>

        </div>

      </div>

    </div>

  </div>

</section>

<section id="contact" class="relative bg-[#061126] py-16 lg:py-24 overflow-hidden">

  <!-- BG EFFECT -->
  <div class="absolute top-0 left-0 w-96 h-96 bg-[#FFD15C]/10 blur-[120px]"></div>
  <div class="absolute bottom-0 right-0 w-96 h-96 bg-blue-500/10 blur-[120px]"></div>

  <div class="relative w-full px-4 sm:px-6 lg:px-8 xl:px-12">

    <div class="grid lg:grid-cols-2 gap-14 items-center">

      <!-- LEFT -->
      <div>

        <p class="text-[#FFD15C] uppercase tracking-[4px] font-bold">
          Contact Us
        </p>

        <h2 class="text-4xl lg:text-6xl font-black text-white mt-5 leading-tight">
          अपने Business को आज ही शुरू करें 🚀
        </h2>

        <p class="text-gray-300 mt-8 text-lg leading-9 max-w-2xl">
          Registration, funding, website development,
          branding और business consultancy के लिए
          हमारी expert team से संपर्क करें।
        </p>

        <!-- CONTACT INFO -->
        <div class="space-y-6 mt-12">

          <!-- ITEM -->
          <div class="flex gap-5 items-start">

            <div class="w-14 h-14 rounded-2xl bg-[#FFD15C]/20 flex items-center justify-center text-2xl">
              📧
            </div>

            <div>

              <h3 class="text-2xl font-black text-white">
                Email Support
              </h3>

              <p class="text-gray-300 mt-2 text-lg">
                support@rozgarsarthi.sprrg.in
              </p>

            </div>

          </div>

          <!-- ITEM -->
          <div class="flex gap-5 items-start">

            <div class="w-14 h-14 rounded-2xl bg-blue-500/20 flex items-center justify-center text-2xl">
              🌐
            </div>

            <div>

              <h3 class="text-2xl font-black text-white">
                Website
              </h3>

              <p class="text-gray-300 mt-2 text-lg">
                rozgarsarthi.sprrg.in
              </p>

            </div>

          </div>

          <!-- ITEM -->
          <div class="flex gap-5 items-start">

            <div class="w-14 h-14 rounded-2xl bg-green-500/20 flex items-center justify-center text-2xl">
              💬
            </div>

            <div>

              <h3 class="text-2xl font-black text-white">
                WhatsApp Support
              </h3>

              <p class="text-gray-300 mt-2 text-lg">
                Quick Business Consultation Available
              </p>

            </div>

          </div>

        </div>

      </div>


      <!-- RIGHT FORM -->
      <!-- RIGHT FORM -->
<div>

  <div class="rounded-[35px] border border-white/10 bg-white/5 backdrop-blur-xl p-8 lg:p-10 shadow-2xl">

    <h3 class="text-4xl font-black text-white">
      Free Consultation
    </h3>

    <p class="text-gray-300 mt-3 text-lg">
      Fill the form and our team will contact you.
    </p>

    <!-- FORM -->
    <form class="space-y-6 mt-10">

      <!-- NAME -->
      <div>

        <label class="text-white font-semibold">
          Full Name
        </label>

        <input
          type="text"
          [(ngModel)]="fullName"
          name="fullName"
          placeholder="Enter your full name"
          class="w-full mt-3 h-14 rounded-2xl bg-white/5 border border-white/10 px-5 text-white outline-none focus:border-[#FFD15C]"
        >

      </div>

      <!-- MOBILE -->
<div>

  <label class="text-white font-semibold">
    Mobile Number
  </label>

  <div class="flex gap-3 mt-3">

    <input
      type="tel"
      [(ngModel)]="mobileNumber"
      name="mobileNumber"
      [disabled]="verified"
      placeholder="Enter mobile number"
      class="flex-1 h-14 rounded-2xl bg-white/5 border border-white/10 px-5 text-white outline-none focus:border-[#FFD15C] disabled:opacity-60"
    >

    <button
      type="button"
      (click)="sendOTP()"
      [disabled]="verified || otpSent"
      class="px-6 rounded-2xl bg-[#FFD15C] text-black font-black transition disabled:opacity-50"
    >

      {{ otpSent ? 'OTP Sent' : 'Send OTP' }}

    </button>

  </div>

</div>

<!-- OTP -->
<div *ngIf="otpSent && !verified" class="mt-6">

  <label class="text-white font-semibold">
    Enter OTP
  </label>

  <div class="flex gap-3 mt-3">

    <input
      type="text"
      [(ngModel)]="otp"
      name="otp"
      maxlength="6"
      placeholder="Enter OTP"
      class="flex-1 h-14 rounded-2xl bg-white/5 border border-white/10 px-5 text-white outline-none focus:border-green-400"
    >

    <button
      type="button"
      (click)="verifyOTP()"
      class="px-6 rounded-2xl bg-green-500 text-white font-black transition"
    >

      Verify OTP

    </button>

  </div>

  <!-- RESEND -->
  <div class="mt-4">

    <button
      type="button"
      (click)="resendOTP()"
      [disabled]="resendDisabled"
      class="text-sm font-semibold text-[#FFD15C] disabled:text-gray-500"
    >

      <span *ngIf="resendDisabled">
        Resend OTP in {{ countdown }} sec
      </span>

      <span *ngIf="!resendDisabled">
        Resend OTP
      </span>

    </button>

  </div>

</div>

<!-- VERIFIED -->
<div
  *ngIf="verified"
  class="mt-6 bg-green-500/20 border border-green-500 text-green-300 p-4 rounded-2xl"
>

  ✅ Mobile Number Verified Successfully

</div>

      <!-- EMAIL -->
      <div>

        <label class="text-white font-semibold">
          Email Address
        </label>

        <input
          type="email"
          [(ngModel)]="email"
          name="email"
          placeholder="Enter your email"
          class="w-full mt-3 h-14 rounded-2xl bg-white/5 border border-white/10 px-5 text-white outline-none focus:border-[#FFD15C]"
        >

      </div>

      <!-- CITY -->
      <div>

        <label class="text-white font-semibold">
        City
        </label>

        <input
          type="text"
         [(ngModel)]="city"
           name="city"
          placeholder="Enter your city"
          class="w-full mt-3 h-14 rounded-2xl bg-white/5 border border-white/10 px-5 text-white outline-none focus:border-[#FFD15C]"
           >

          </div>

        <!-- PINCODE -->
        <div>

         <label class="text-white font-semibold">
          Pincode
          </label>

            <input
             type="text"
          [(ngModel)]="pincode"
           name="pincode"
           placeholder="Enter pincode"
             class="w-full mt-3 h-14 rounded-2xl bg-white/5 border border-white/10 px-5 text-white outline-none focus:border-[#FFD15C]"
               >

          </div>

      <!-- BUSINESS TYPE -->
      <div>

        <label class="text-white font-semibold">
          Business Type
        </label>

        <input
          type="text"
          [(ngModel)]="businessType"
          name="businessType"
          placeholder="Startup / Shop / Company"
          class="w-full mt-3 h-14 rounded-2xl bg-white/5 border border-white/10 px-5 text-white outline-none focus:border-[#FFD15C]"
        >

      </div>

      <!-- INVESTMENT -->
      <div>

        <label class="text-white font-semibold">
          Minimum Investment Amount
        </label>

        <input
          type="text"
          [(ngModel)]="investmentAmount"
          name="investmentAmount"
          placeholder="₹ 20,000"
          class="w-full mt-3 h-14 rounded-2xl bg-white/5 border border-white/10 px-5 text-white outline-none focus:border-[#FFD15C]"
        >

      </div>

      <!-- MESSAGE -->
      <div>

        <label class="text-white font-semibold">
          Message
        </label>

        <textarea
          rows="5"
          [(ngModel)]="message"
          name="message"
          placeholder="Tell us about your business requirement"
          class="w-full mt-3 rounded-2xl bg-white/5 border border-white/10 px-5 py-4 text-white outline-none focus:border-[#FFD15C]"
        ></textarea>

      </div>

      <!-- BUTTON -->
      <button
        type="button"
        (click)="submitForm()"
        [disabled]="!verified"
        class="w-full h-14 rounded-2xl bg-[#FFD15C] text-black font-black text-lg hover:scale-[1.02] transition"
      >

        Submit Inquiry

      </button>

      <!-- INVISIBLE RECAPTCHA -->
      <div id="recaptcha-container"></div>

    </form>

  </div>

</div>

    </div>

  </div>

</section>


<footer class="relative bg-[#040B1C] overflow-hidden border-t border-white/10">

  <!-- BG EFFECT -->
  <div class="absolute top-0 left-0 w-96 h-96 bg-[#FFD15C]/10 blur-[120px]"></div>

  <div class="relative w-full px-4 sm:px-6 lg:px-8 xl:px-12 py-16">

    <!-- TOP -->
    <div class="grid md:grid-cols-2 lg:grid-cols-4 gap-12">

      <!-- BRAND -->
      <div>

        <div class="flex items-center gap-4">

          <img
            src="/logo.png"
            alt="Rozgar Sarthi"
            class="h-16 w-auto object-contain"
          >

          <div>

            <h2 class="text-3xl font-black text-[#FFD15C]">
              Rozgar Sarthi
            </h2>

            <p class="text-xs text-gray-400 mt-1">
              Startup • Funding • Business Growth
            </p>

          </div>

        </div>

        <p class="text-gray-300 mt-8 leading-8 text-lg">
          Rozgar Sarthi युवाओं, startups और business owners
          को registration, funding, branding एवं digital
          business setup में सहायता प्रदान करता है।
        </p>

      </div>


      <!-- SERVICES -->
      <div>

        <h3 class="text-2xl font-black text-white">
          Services
        </h3>

        <div class="flex flex-col gap-4 mt-8 text-gray-300">

          <a href="#" class="hover:text-[#FFD15C] transition">
            Company Registration
          </a>

          <a href="#" class="hover:text-[#FFD15C] transition">
            GST Registration
          </a>

          <a href="#" class="hover:text-[#FFD15C] transition">
            Website Development
          </a>

          <a href="#" class="hover:text-[#FFD15C] transition">
            Branding & Marketing
          </a>

          <a href="#" class="hover:text-[#FFD15C] transition">
            Startup India
          </a>

        </div>

      </div>


      <!-- FUNDING -->
      <div>

        <h3 class="text-2xl font-black text-white">
          Funding Support
        </h3>

        <div class="flex flex-col gap-4 mt-8 text-gray-300">

          <a href="#" class="hover:text-[#FFD15C] transition">
            PMEGP Loan
          </a>

          <a href="#" class="hover:text-[#FFD15C] transition">
            Mudra Loan
          </a>

          <a href="#" class="hover:text-[#FFD15C] transition">
            MSME Loan
          </a>

          <a href="#" class="hover:text-[#FFD15C] transition">
            Startup India Funding
          </a>

          <a href="#" class="hover:text-[#FFD15C] transition">
            Government Subsidy
          </a>

        </div>

      </div>


      <!-- CONTACT -->
      <div>

        <h3 class="text-2xl font-black text-white">
          Contact
        </h3>

        <div class="space-y-5 mt-8">

          <div>

            <p class="text-gray-400 text-sm">
              Website
            </p>

            <p class="text-white text-lg mt-2 break-all">
              rozgarsarthi.sprrg.in
            </p>

          </div>

          <div>

            <p class="text-gray-400 text-sm">
              Email
            </p>

            <p class="text-white text-lg mt-2 break-all">
              support@rozgarsarthi.sprrg.in
            </p>

          </div>

          <div>

            <p class="text-gray-400 text-sm">
              Support
            </p>

            <p class="text-white text-lg mt-2">
              24/7 Business Guidance
            </p>

          </div>

        </div>

      </div>

    </div>


    <!-- DIVIDER -->
    <div class="border-t border-white/10 mt-16 pt-8">

      <div class="flex flex-col lg:flex-row items-center justify-between gap-6">

        <!-- COPYRIGHT -->
        <p class="text-gray-400 text-center lg:text-left">
          © 2026 Rozgar Sarthi. All Rights Reserved.
        </p>

        <!-- SOCIAL -->
        <div class="flex items-center gap-5">

          <a
            href="#"
            class="w-12 h-12 rounded-2xl bg-white/5 border border-white/10 flex items-center justify-center text-xl hover:bg-[#FFD15C] hover:text-black transition"
          >
            📘
          </a>

          <a
            href="#"
            class="w-12 h-12 rounded-2xl bg-white/5 border border-white/10 flex items-center justify-center text-xl hover:bg-[#FFD15C] hover:text-black transition"
          >
            📷
          </a>

          <a
            href="#"
            class="w-12 h-12 rounded-2xl bg-white/5 border border-white/10 flex items-center justify-center text-xl hover:bg-[#FFD15C] hover:text-black transition"
          >
            💼
          </a>

          <a
            href="#"
            class="w-12 h-12 rounded-2xl bg-white/5 border border-white/10 flex items-center justify-center text-xl hover:bg-[#FFD15C] hover:text-black transition"
          >
            ▶️
          </a>

        </div>

      </div>

    </div>

  </div>

</footer>

<!-- ULTRA PREMIUM WHATSAPP BUTTON -->
<a
  href="https://wa.me/916390069555"
  target="_blank"
  class="group fixed bottom-24 right-5 z-50"
>

  <!-- PING EFFECT -->
  <span class="absolute inset-0 rounded-full bg-green-500 animate-ping opacity-20"></span>

  <!-- MAIN BUTTON -->
  <div class="relative flex items-center gap-4 bg-gradient-to-r from-green-500 to-emerald-600 shadow-[0_10px_40px_rgba(34,197,94,0.45)] rounded-full pl-5 pr-6 py-4 border border-white/10 backdrop-blur-xl hover:scale-105 transition duration-300">

    <!-- ICON -->
    <div class="w-14 h-14 rounded-full bg-white flex items-center justify-center shadow-lg text-3xl">

      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 32 32"
        class="w-8 h-0"
        fill="#25D366"
      >
        <path d="M19.11 17.2c-.29-.15-1.69-.83-1.95-.92-.26-.1-.45-.15-.64.15-.19.29-.73.92-.89 1.11-.16.19-.32.22-.61.07-.29-.15-1.2-.44-2.28-1.41-.84-.75-1.4-1.67-1.56-1.95-.16-.29-.02-.44.12-.59.13-.13.29-.34.44-.51.15-.17.19-.29.29-.49.1-.19.05-.37-.02-.51-.07-.15-.64-1.55-.88-2.13-.23-.55-.46-.47-.64-.48-.16-.01-.35-.01-.54-.01-.19 0-.49.07-.75.37-.26.29-.98.96-.98 2.34s1 2.71 1.14 2.9c.15.19 1.97 3 4.78 4.2.67.29 1.2.46 1.61.59.68.22 1.3.19 1.79.12.55-.08 1.69-.69 1.93-1.36.24-.67.24-1.24.17-1.36-.07-.12-.26-.19-.55-.34z"/>
        <path d="M16.02 3C8.84 3 3 8.84 3 16c0 2.58.75 5.09 2.18 7.24L3 29l5.92-2.12A12.9 12.9 0 0016.02 29C23.18 29 29 23.16 29 16S23.18 3 16.02 3zm0 23.6c-2.1 0-4.14-.57-5.92-1.66l-.42-.25-3.51 1.26 1.14-3.42-.27-.44A10.52 10.52 0 015.4 16c0-5.86 4.76-10.62 10.62-10.62S26.64 10.14 26.64 16 21.88 26.6 16.02 26.6z"/>
      </svg>

    </div>

    <!-- TEXT -->
    <div>

      <p class="text-xs text-green-100 font-medium tracking-wide">
        Need Help?
      </p>

      <h3 class="text-white text-lg font-black leading-none mt-1">
        Chat on WhatsApp
      </h3>

    </div>

  </div>

</a>



</div>